import CopyWidgetsDialog from './CopyWidgetsDialog';
export default CopyWidgetsDialog;



// WEBPACK FOOTER //
// ./src/scenes/Report/components/ReportWrapper/components/ReportHeader/components/CopyWidgetsDialog/index.js